module.exports = __webpack_public_path__ + "./Nao2_404e7b68358a33606ff362382297e625.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Nao2.png
// module id = 573
// module chunks = 0